import { getSfcoreAccessKeyDomains, getSfcoreUrl } from '@/helpers/envHelper';

const getSessionInfo = async () => {
  try {
    const sfcoreUrl = getSfcoreUrl();
    const apiAccessKey = getSfcoreAccessKeyDomains();

    if (!sfcoreUrl || !apiAccessKey) {
      return null;
    }

    const response = await fetch(sfcoreUrl+'?method=getSessionInfo', {
      body: JSON.stringify({
        request: {
          requestInfo: {
            apiAccessKey,
            clientId: 'AccountManager',
            method: 'getSessionInfo',
            service: 'SessionAPI',
          },
        },
      }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    let json;

    try {
      json = await response.json();
    } catch {
      console.error('Error parsing session info response:', response);
      return null;
    }

    return json?.response?.data ?? null;
  } catch (error) {
    console.error('Network error:', error);
    return null;
  }
};

export default getSessionInfo;
